<div class="main flex flex-col gap-[48px] lt-md:gap-[16px]">
  <div class="flex gt-sm:flex-row lt-md:flex-col gap-[16px]">
    <app-jumbotron
      class="flex flex-col gap-[24px] lt-md:gap-[16px] flex-[100%] max-w-[50%] lt-md:max-w-full lt-md:flex-auto"
      [matTooltip]="
        isAddRoomDisabled
          ? ('+COMMISSIONING.OVERVIEW.TOOLTIP.ADD_ROOM_NOT_POSSIBLE' | translate)
          : null
      "
    >
      <h3>{{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM' | translate }}</h3>
      <vi-text>
        {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM_DESCRIPTION' | translate }}
      </vi-text>
      <div class="jumbotron-grid">
        <button
          class="btn-jumbotron"
          mat-raised-button
          color="primary"
          gtm="onOpen"
          gtmAction="Add room dialog"
          gtmCategory="commissioning"
          (click)="onAddRoom(isAddRoomDisabled)"
          [disabled]="isAddRoomDisabled"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_ROOM' | translate }}</span>
        </button>
        <button
          class="btn-jumbotron"
          mat-button
          color="primary"
          gtm="onOpen"
          gtmAction="All added rooms modal"
          gtmCategory="commissioningOverview"
          [disabled]="(installationFeaturesStore.rooms$ | async).length === 0"
          (click)="openAllAddedRoomsDialog()"
        >
          <span
            >{{ '+COMMISSIONING.OVERVIEW.BUTTON.SHOW_ALL_ROOMS' | translate }} ({{
              (installationFeaturesStore.rooms$ | async).length
            }})</span
          >
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      </div>
    </app-jumbotron>
    <app-jumbotron
      class="flex flex-col gap-[24px] lt-md:gap-[16px] flex-[100%] max-w-[50%] lt-md:max-w-full lt-md:flex-auto"
    >
      <h3>
        {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE' | translate }}
      </h3>
      <vi-text>
        {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE_DESCRIPTION' | translate }}
      </vi-text>
      <div class="jumbotron-grid">
        <button
          mat-raised-button
          color="primary"
          gtm="onOpen"
          gtmAction="Add device dialog"
          gtmCategory="commissioning"
          class="clickable-box btn-jumbotron"
          data-at-comissioning-room-btn-add-device
          (click)="onAddDevice()"
          [disabled]="isAddDeviceDisabled"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE' | translate }}</span>
        </button>
      </div>
    </app-jumbotron>
  </div>

  <div class="!hidden lt-md:!block"></div>

  <h2>{{ '+COMMISSIONING.OVERVIEW.ROOMS_OVERVIEW.TITLE' | translate }}</h2>

  <app-filters>
    <app-filter
      data-at-comissioning-filter-all
      data-at-filter-all-rooms
      [active]="activeRoomsFilter === filterType.ALL"
      [count]="(installationFeaturesStore.rooms$ | async).length"
      gtm="onSetFilter"
      gtmCategory="commissioningOverview"
      gtmLabel="{{ filterType.ALL }}"
      (click)="setFilter(filterType.ALL)"
    >
      {{ '+COMMISSIONING.OVERVIEW.FILTER_ROOMS.ALL' | translate }}
    </app-filter>
    <app-filter
      data-at-comissioning-filter-assigned
      data-at-filter-assigned-rooms
      [active]="activeRoomsFilter === filterType.ASSIGNED"
      [count]="(installationFeaturesStore.assignedRooms$ | async).length"
      gtm="onSetFilter"
      gtmCategory="commissioningOverview"
      gtmLabel="{{ filterType.ASSIGNED }}"
      (click)="setFilter(filterType.ASSIGNED)"
    >
      {{ '+COMMISSIONING.OVERVIEW.FILTER_ROOMS.ASSIGNED' | translate }}
    </app-filter>
    <app-filter
      data-at-comissioning-filter-unassigned
      [active]="activeRoomsFilter === filterType.UNASSIGNED"
      [count]="(installationFeaturesStore.unassignedRooms$ | async).length"
      gtm="onSetFilter"
      gtmCategory="commissioningOverview"
      gtmLabel="{{ filterType.UNASSIGNED }}"
      (click)="setFilter(filterType.UNASSIGNED)"
    >
      {{ '+COMMISSIONING.OVERVIEW.FILTER_ROOMS.UNASSIGNED' | translate }}
    </app-filter>
  </app-filters>

  <div class="!hidden lt-md:!block"></div>

  <ng-container [ngSwitch]="activeRoomsFilter">
    <ng-container *ngSwitchCase="filterType.ALL">
      <app-list *ngIf="installationFeaturesStore.rooms$ | async as rooms">
        <app-list-item
          *ngFor="let room of rooms; index as index"
          #appListAll
          [attr.uri]="room.uri"
          [class.highlight-list-item]="index === highlightIndex"
        >
          <app-src-room [room]="room"></app-src-room>
        </app-list-item>
        <app-list-item *ngIf="!rooms?.length">
          <app-tile>{{ '+COMMISSIONING.ROOMS.NO_ROOMS' | translate }}</app-tile>
        </app-list-item>
      </app-list>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.ASSIGNED">
      <app-list *ngIf="installationFeaturesStore.assignedRooms$ | async as assignedRooms">
        <app-list-item *ngFor="let room of assignedRooms">
          <app-src-room [room]="room"></app-src-room>
        </app-list-item>
        <app-list-item *ngIf="!assignedRooms?.length">
          <app-tile>{{ '+COMMISSIONING.ROOMS.NO_ASSIGNED_ROOMS' | translate }}</app-tile>
        </app-list-item>
      </app-list>
    </ng-container>

    <ng-container *ngSwitchCase="filterType.UNASSIGNED">
      <app-list *ngIf="installationFeaturesStore.unassignedRooms$ | async as unassignedRooms">
        <app-list-item *ngFor="let room of unassignedRooms">
          <app-src-room [room]="room"></app-src-room>
        </app-list-item>
        <app-list-item *ngIf="!unassignedRooms?.length">
          <app-tile>{{ '+COMMISSIONING.ROOMS.NO_UNASSIGNED_ROOMS' | translate }}</app-tile>
        </app-list-item>
      </app-list>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!(devicesStore.isSelectedDeviceOBNG$ | async)">
    <ng-container *ngIf="notAssignedHCsToOtherRooms$ | async as notAssignedHCs">
      <ng-container *ngIf="installationFeaturesStore.otherRoomsFeature$ | async | ready as feature">
        <ng-container *ngIf="otherRooms$ | async as otherRooms">
          <ng-container *ngIf="otherRooms.length || notAssignedHCs.length">
            <div class="!hidden lt-md:!block"></div>
            <h2>{{ '+COMMISSIONING.OVERVIEW.OTHER_ROOMS.TITLE' | translate }}</h2>

            <app-list>
              <app-list-item *ngFor="let notAssignedHC of notAssignedHCs">
                <app-src-not-added-other-room
                  [isAddCommandExecutable]="feature?.commands?.add?.isExecutable"
                  [enabled]="installationFeaturesStore.isAnyRoomWithDevice$ | async"
                  [heatingCircuit]="notAssignedHC"
                ></app-src-not-added-other-room>
              </app-list-item>

              <app-list-item *ngFor="let otherRoom of otherRooms; trackBy: otherRoomNameTrackBy">
                <app-src-other-room
                  [otherRoom]="otherRoom"
                  [active]="otherRoom?.properties?.active?.value"
                  [enabled]="installationFeaturesStore.isAnyRoomWithDevice$ | async"
                ></app-src-other-room>
              </app-list-item>
            </app-list>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!(gatewayStore.unassignableDevicesFlag$ | async).empty">
    <div class="!hidden lt-md:!block"></div>
    <h2>{{ '+COMMISSIONING.OVERVIEW.DEVICES_OVERVIEW.TITLE' | translate }}</h2>

    <app-list *ngIf="unAssignableDevices$ | async as unAssignableDevices">
      <ng-container *ngFor="let device of unAssignableDevices">
        <app-list-item *ngIf="device.devices.length">
          <app-src-devices [deviceGroup]="device"> </app-src-devices>
        </app-list-item>
      </ng-container>
    </app-list>
  </ng-container>
</div>
